import React from 'react'
import classnames from 'classnames'
import { object } from 'prop-types'
import { hasValue } from '../../../../services/util/CommonUtil'
import Skeleton from '../../../../components/library/loaders/Skeleton'

const AgentListRow = ({ agent, isSelected, onSelected }) => 
    <div className='columns'>
        {agent ?
            <div className='agent-row column is-10 is-offset-1 columns px-0 my-0 py-1'>
                <div className='column is-6 pl-0'>{hasValue(agent.id) ? `${agent.firstName} ${agent.lastName}` : <Skeleton />}</div>
                <div className='column is-4 pl-2'>{hasValue(agent.id) ? agent.officeId : <Skeleton />}</div>
                <div className='column is-2'>
                    <div className='hrb-radio-wrapper' onClick={() => onSelected(agent.id)}>
                        <div id={`select-agent-${agent.id}`} className={classnames('hrb-radio-button', { 'checked': isSelected })} />
                    </div>
                </div>
            </div>
            :
            <div className='agent-row column is-10 is-offset-1 columns px-0 my-0 py-1'>
                <div className='column is-6 pl-0'><Skeleton width='175px' /></div>
                <div className='column is-4 pl-2'><Skeleton width='85px' /></div>
                <div className='column is-2'><Skeleton width='24px' />
                </div>
            </div>
        }
    </div>

AgentListRow.propTypes = {
    agent: object,
}

export default AgentListRow